import { DoqFaceSvgProps } from '../types';

const ComponentMatrixError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#clip0_2696_48787)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-component-matrix-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#76D1A5"
        mask="url(#bottom-mask-component-matrix-error)"
      />
      <mask
        id="mask0_0923_43563"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_0923_43563)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2974C4"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 200C153.078 200 147.907 203.217 145.141 208L150.056 208C152.253 205.545 155.446 204 159 204C162.554 204 165.747 205.545 167.944 208L172.859 208C170.093 203.217 164.922 200 159 200Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130 161.5C127.791 161.5 126 163.291 126 165.5V186.5C126 188.709 127.791 190.5 130 190.5H151C153.209 190.5 155 188.709 155 186.5V179.5H165V186.5C165 188.709 166.791 190.5 169 190.5H190C192.209 190.5 194 188.709 194 186.5V165.5C194 163.291 192.209 161.5 190 161.5H169C166.791 161.5 165 163.291 165 165.5V176.5H155V165.5C155 163.291 153.209 161.5 151 161.5H130ZM151 164.5H130C129.448 164.5 129 164.948 129 165.5V186.5C129 187.052 129.448 187.5 130 187.5H151C151.552 187.5 152 187.052 152 186.5V165.5C152 164.948 151.552 164.5 151 164.5ZM190 164.5H169C168.448 164.5 168 164.948 168 165.5V186.5C168 187.052 168.448 187.5 169 187.5H190C190.552 187.5 191 187.052 191 186.5V165.5C191 164.948 190.552 164.5 190 164.5Z"
        fill="#2974C4"
      />
      <g opacity="0.5">
        <path
          d="M96 232C91.5817 232 88 235.582 88 240V249.5L136 249.5V232H96Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M136.5 232V249.5L184 249.5V232H136.5ZM142 234C140.895 234 140 234.895 140 236V245C140 246.105 140.895 247 142 247H179C180.105 247 181 246.105 181 245V236C181 234.895 180.105 234 179 234H142Z"
          fill="#2974C4"
        />
        <path
          d="M184.5 232V249.5L232 249.5V240C232 235.582 228.418 232 224 232H184.5Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M232 250L184.5 250V267.5L232 267.5V250ZM187.5 254C187.5 252.895 188.395 252 189.5 252H226.5C227.605 252 228.5 252.895 228.5 254V263C228.5 264.105 227.605 265 226.5 265H189.5C188.395 265 187.5 264.105 187.5 263V254Z"
          fill="#2974C4"
        />
        <path d="M232 268L184.5 268V285.5L232 285.5V268Z" fill="#2974C4" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M232 286L184.5 286V304H224C228.418 304 232 300.418 232 296V286ZM187.5 290C187.5 288.895 188.395 288 189.5 288H226.5C227.605 288 228.5 288.895 228.5 290V299C228.5 300.105 227.605 301 226.5 301H189.5C188.395 301 187.5 300.105 187.5 299V290Z"
          fill="#2974C4"
        />
        <path d="M184 304V286L136.5 286V304H184Z" fill="#2974C4" />
        <path
          d="M136 304V286L88 286V296C88 300.418 91.5817 304 96 304H136Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M88 285.5L136 285.5V268L88 268V285.5ZM92 272C92 270.895 92.8954 270 94 270H131C132.105 270 133 270.895 133 272V281C133 282.105 132.105 283 131 283H94C92.8954 283 92 282.105 92 281V272Z"
          fill="#2974C4"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M88 267.5L136 267.5V250L88 250V267.5ZM94 252C92.8954 252 92 252.895 92 254V263C92 264.105 92.8954 265 94 265H131C132.105 265 133 264.105 133 263V254C133 252.895 132.105 252 131 252H94Z"
          fill="#2974C4"
        />
        <path d="M184 267.5V250L136.5 250V267.5L184 267.5Z" fill="#2974C4" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M136.5 268L184 268V285.5L136.5 285.5V268ZM140 272C140 270.895 140.895 270 142 270H179C180.105 270 181 270.895 181 272V281C181 282.105 180.105 283 179 283H142C140.895 283 140 282.105 140 281V272Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2696_48787">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { ComponentMatrixError };
